import { render } from "./nationalityPacakgePrice.vue?vue&type=template&id=0f09adc3&scoped=true"
import script from "./nationalityPacakgePrice.vue?vue&type=script&lang=js"
export * from "./nationalityPacakgePrice.vue?vue&type=script&lang=js"

import "./nationalityPacakgePrice.vue?vue&type=style&index=0&id=0f09adc3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f09adc3"]])

export default __exports__